import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import Home from './pages/Index/Home';
import CssBaseline from '@mui/material/CssBaseline';
import SeriesHistoricasPainel from './pages/Painel/SeriesHistoricasPainel';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import { ThemeProvider } from '@mui/material/styles';

import { ApolloClient, HttpLink, ApolloProvider, InMemoryCache } from '@apollo/client';
import ResponsiveAppBar from './ResponsiveAppBar';
import theme from './themes';
import Footer from './Footer';
import SolicitantePainel from './pages/Painel/SolicitantePainel';
import DadosGeraisAtendimentoPainel from './pages/Painel/DadosGeraisAtendimentoPainel';
import DadosExposicaoVitimaHumanaPainel from './pages/Painel/DadosExposicaoVitimaHumanaPainel';
import DadosExposicaoVitimaHumanaExposicaoPainel from './pages/Painel/DadosExposicaoVitimaHumanaExposicaoPainel';
import DadosExposicaoVitimaHumanaEncerramentoPainel from './pages/Painel/DadosExposicaoVitimaHumanaEncerramentoPainel';
import DadosExposicaoVitimaHumanaDGrupoAPainel from './pages/Painel/DadosExposicaoVitimaHumanaDGrupoAPainel';
import DadosExposicaoVitimaHumanaDGrupoClasseAPainel from './pages/Painel/DadosExposicaoVitimaHumanaDGrupoClasseAPainel';
import { SystemConstants } from '@datatox-bi/util';

function customKey(args) {  
    console.log('CACHE', JSON.stringify(args));
    return args?.atributo;
}

const httpLink = new HttpLink({ uri: `${process.env.REACT_APP_API_URL}/analise/graphql`, useGETForQueries: true });
const client = new ApolloClient({
    link: httpLink,
    cache: new InMemoryCache({
        addTypename: false,
    }),
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <ApolloProvider client={client}>
            <ThemeProvider theme={theme}>
                <BrowserRouter>
                    <ResponsiveAppBar />
                    <Routes>
                        <Route path="/" element={<Navigate to={SystemConstants.SiteMapInterno.INICIO} replace />} />
                        <Route path={SystemConstants.SiteMapInterno.INICIO} element={<Home />} />
                        <Route path={SystemConstants.SiteMapInterno.SERIES_HISTORICAS} element={<SeriesHistoricasPainel />} />
                        <Route path={SystemConstants.SiteMapInterno.SOLICITANTE} element={<SolicitantePainel />} />
                        <Route path={SystemConstants.SiteMapInterno.DADOS_GERAIS_ATENDIMENTO} element={<DadosGeraisAtendimentoPainel />} />
                        <Route path={SystemConstants.SiteMapInterno.DADOS_EXPOSICAO_VITIMA_HUMANA} element={<DadosExposicaoVitimaHumanaPainel />} />
                        <Route
                            path={SystemConstants.SiteMapInterno.DADOS_EXPOSICAO_VITIMA_HUMANA_EXPOSICAO}
                            element={<DadosExposicaoVitimaHumanaExposicaoPainel />}
                        />
                        <Route
                            path={SystemConstants.SiteMapInterno.DADOS_EXPOSICAO_VITIMA_HUMANA_ENCERRAMENTO}
                            element={<DadosExposicaoVitimaHumanaEncerramentoPainel />}
                        />
                        <Route
                            path={SystemConstants.SiteMapInterno.DADOS_EXPOSICAO_VITIMA_HUMANA_DADOS_POR_GRUPO_DE_AGENTES}
                            element={<DadosExposicaoVitimaHumanaDGrupoAPainel />}
                        />
                        <Route
                            path={SystemConstants.SiteMapInterno.DADOS_EXPOSICAO_VITIMA_HUMANA_DADOS_POR_GRUPO_E_CLASSE_DOS_AGENTES}
                            element={<DadosExposicaoVitimaHumanaDGrupoClasseAPainel />}
                        />
                    </Routes>
                    <Footer />
                </BrowserRouter>
            </ThemeProvider>
        </ApolloProvider>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
